export const environment = {
  production: true,
  supportHttp: 'https://ms.utaxcloud.net',
  mirandaHttp: 'https://balanced.utaxcloud.net',
  passengerMirandaHttp: 'https://ms.utaxcloud.net/passenger',
  driverMirandaHttp: 'https://ms.utaxcloud.net/driver',
  dispatcherMirandaHttp: 'https://ms.utaxcloud.net/dispatcher',
  cdnHttp: 'https://ms.utaxcloud.net',
};
